import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=53b78ab1&scoped=true&component=true&componentId=index23a1b4ec"
import script from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index23a1b4ec"
export * from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index23a1b4ec"
import style0 from "./index.mpx?vue&type=style&index=0&id=53b78ab1&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m23a1b4ec%22%7D&component=true&componentId=index23a1b4ec"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b78ab1",
  null
  
)

export default component.exports